import { render, staticRenderFns } from "./SeparateMessageContentSlack.vue?vue&type=template&id=348b6f12&"
import script from "./SeparateMessageContentSlack.vue?vue&type=script&lang=js&"
export * from "./SeparateMessageContentSlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QInput});
